// extracted by mini-css-extract-plugin
export default {"container":"indicatorsCard_container__v9TUY"};